import React, { useEffect, useState } from 'react';
import Civildropdown from './CivildropDown';
import { BASE_URL } from '../../../insightConfig/insightConfig';
import axios from 'axios';
import { selectNewSubjectAndSectionRandomly } from '../../../commonServices/commonService';

const Civil = () => {
  const [subjects, setSubjects] = useState([]);
  const [dynamicSubjectURL, setDynamicSubjectURL] = useState([]);
  const [dynamicSectionURL, setDynamicSectionURL] = useState([]);
  useEffect(() => {
    const fetchData = async () => {
      const response = await axios.get(`${BASE_URL}/getSubjectAndSections`);
      let subjects = response?.data?.data;
      setSubjects(subjects);
      const response1 = selectNewSubjectAndSectionRandomly(subjects);
      setDynamicSubjectURL(response1.subjectURL);
      setDynamicSectionURL(response1.sectionURL);
    }
    fetchData()
  }, []);

  const civil = [
    {
      title: 'Home',
      links: [
        { label: 'About Us', url: 'about/Insight-Academy-Delhi' },
        { label: 'Pattern Of Exam', url: '/about/pattern-of-exam' },
        { label: 'Syllabus', url: '/about/ias-exam-syllabus' },
        { label: 'Sample Notes', url: '/about/Sample-Notes-for-ias-exam' },
        { label: 'FAQs', url: '/about/frequently-asked-questions-about-ias-exam' },
        // Add more links for the 'Home' category
      ]
    },
    {
      title: 'GENERAL STUDIES',
      links: [
        {
          label: 'Super Platinum GS Course', url: `/course/super-platinum-gs-foundation-course`
        },
        {
          label: 'GS Foundation Course', url: `/course/GS-Foundation-Course`
        },
        { label: 'GS Prelims Course', url: `/course/GS-Prelims-Course` },
        { label: 'GS Main Course', url: `/course/GS-Mains-Course` },
        { label: 'Ethics, Aptitude And Integrity', url: `/course/Ethics-Aptitude-and-Integrity` }, 

        { label: 'INSIGHT Mentorship Programme', url: `/course/mentorship-programme` },
        // Add more links for 'GENERAL STUDIES' category
      ]
    },
    {
      title: 'HISTORY',
      links: [
        { label: 'History Optional Online', url: `/course/History-Optional-Online` },
        { label: 'History Optional Offline', url: `/course/History-Optional-Offline` },
        { label: 'GS History And Culture', url: `/course/History-and-Culture` },
        { label: 'Art and Culture', url: `/course/Art-and-Culture-Course` },
        { label: 'Hist. Opt. Map Classes', url: `/course/history-optional` },
        // Add more links for 'HISTORY' category
      ]
    }



  ];

  const civil1 = [
    {
      title: '',
      links: []
    },
    {
      title: 'Test Series',
      links: [
        { label: 'GS Pre-Cum-Mains Test Series', url: '/testseries/gs-pre-cum-mains-test-series' },
        {
          label: 'GS Mains Test Series', url: '/testseries/gs-mains-test-series'
        },
        { label: 'GS Prelims Test Series', url: '/testseries/gs-prelims-test-series' },
        { label: 'History Optional Test Series', url: '/testseries/history-optional-test-series' },
        { label: 'Essay Test Series', url: '/testseries/essay-test-series' },
        // Add more links for 'Test Series' category
      ]
    },
    {
      title: 'Success Mantra',
      links: [
        { label: 'CSE Prelims 2026 Answer Key', url: '/about/cse-prelims-exam' },
        { label: 'CSE Main Exam 2026', url: '/about/upsc-cse-mains' },
        { label: 'Topper\'s Strategy', url: '/about/ias-toppers-strategy' },
        { label: 'Strategy For Hist. Optional', url: '/about/strategy-for-history-optional' },
        { label: 'Interview Guidance Program', url: '/interview-guidance-program' },
        // Add more links for 'Success Mantra' category
      ]
    },
    {
      title: 'Free Course',
      links: [
        { label: 'UPSC QUIZ', url: `/upsc-quiz/${dynamicSubjectURL}/${dynamicSectionURL}` },
        { label: 'Art And Culture Book', url: '/books/art-and-culture' },
        { label: 'Book List For GS', url: '/about/Book-List-for-General-Studies' },
        { label: 'Book List For Hist. Opt', url: '/about/History-optional-Book-List-and-syllabus-for-ias-exam' },
        { label: 'Imp. Websites', url: '/about/important-websites-for-online-preparation-of-ias-exam' },
        // Add more links for 'Free Course' category
      ]
    },
    // Add more categories as needed following the same structure
  ]
  //Civil Drop Down Data Section End

  return (
    <div>
      <Civildropdown civil={civil} civil1={civil1} />
    </div>
  );
};

export default Civil;
